import { createContext, useState } from "react";

export const LayoutContext = createContext();

export const LayoutProvider = ({ children }) => {
  const [isBannerVisible, setBannerVisible] = useState(false);

  return (
    <LayoutContext.Provider value={{ isBannerVisible, setBannerVisible }}>
      {children}
    </LayoutContext.Provider>
  );
};
